import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Grid,
  TextField,
  Button,
} from "@mui/material";

export default function JoinLeagueDialog({
  open,
  onClose,
  onJoin,
  leagueCode,
  setLeagueCode,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">Join League</DialogTitle>
      <DialogContent>
        <Grid container>
          <Grid item xs={12} sx={{ m: 0, p: 1 }}>
            <TextField
              id="code"
              label="League Code"
              fullWidth
              value={leagueCode}
              variant="standard"
              onChange={(e) => setLeagueCode(e.target.value)}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={onJoin} autoFocus disabled={leagueCode.length < 6}>
          Join
        </Button>
      </DialogActions>
    </Dialog>
  );
}
